module.exports = __webpack_public_path__ + "static/img/14000783.8d86893a.png";